import { Directive, inject } from '@angular/core'
import { ElderSelectComponent, Sort } from '@elderbyte/ngx-starter'
import { DeliveryService } from './delivery.service'

@Directive({
  selector: '[appDeliverySelect]',
})
export class DeliverySelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)
  private deliveryService = inject(DeliveryService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.displayProperty = 'id'
    this.select.dataSource = this.deliveryService
    this.select.sorts = [new Sort('id', 'asc')]
  }
}
